/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  ITransactionsListMethods,
  TransactionsListService,
  IRevokeCredentialMethods,
  RevokeCredentialService,
  LoadingService,
  ILoadingMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IResendCredentialMethods,
  ResendCredentialService,
  FooterService,
  IFooterMethods,
} from './components';

export type SuppChainTransAgent = IHeaderMethods &
  ISettingsMethods &
  ITransactionsListMethods &
  IRevokeCredentialMethods &
  IStaticPageContentMethods &
  IResendCredentialMethods &
  ILoadingMethods &
  IFooterMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new SettingsService(),
    new TransactionsListService(),
    new RevokeCredentialService(),
    new LoadingService(),
    new StaticPageContentService(),
    new ResendCredentialService(),
    new FooterService(),
  ];
};

export const getAgent = () => {
  return createAgent<SuppChainTransAgent>({
    plugins: getPlugins(),
  });
};
